import { UserFindDto, type UserFindInterface } from '@zaoblako/shared/modules/security/dtos/user/user-find.dto';
import { MasterMilestoneFormDto, type MasterMilestoneFormInterface } from '@zaoblako/shared/modules/catalog/dtos/master-milestone/master-milestone-form.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { CatalogDtosKeysEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-dtos-keys.enum';

import * as yup from 'yup';

export interface MasterMilestoneFindInterface extends MasterMilestoneFormInterface {
  /** Unique identifier. Cannot be changed. */
  id: number;
  /** Creation date and time */
  created: Date;
  /** Last update date and time */
  updated: Date;
  /** Soft delete date and time */
  deleted: Date;
  /** Master milestone creator */
  createdBy?: UserFindInterface;
}

export const MasterMilestoneFindDto = SerdeDtoClass.from<MasterMilestoneFormInterface, MasterMilestoneFindInterface>(
  MasterMilestoneFormDto,
  CatalogDtosKeysEnum.MASTER_MILESTONE_FIND_DTO,
  {
    id: {
      label: 'Номер',
      serializer: yup.number(),
    },
    created: {
      label: 'Создан',
      serializer: yup.date(),
    },
    updated: {
      label: 'Изменен',
      serializer: yup.date(),
    },
    deleted: {
      optional: true,
      label: 'Удален',
      serializer: yup.date(),
    },
    createdBy: {
      optional: true,
      label: 'Автор',
      nested: UserFindDto,
      serializer: (_, nested) => nested,
    },
  },
);
